import { render, staticRenderFns } from "./mediaPlatformManage.vue?vue&type=template&id=28c37937&scoped=true&"
import script from "./mediaPlatformManage.vue?vue&type=script&lang=js&"
export * from "./mediaPlatformManage.vue?vue&type=script&lang=js&"
import style0 from "./mediaPlatformManage.vue?vue&type=style&index=0&id=28c37937&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c37937",
  null
  
)

component.options.__file = "mediaPlatformManage.vue"
export default component.exports